<template functional>
  <div class="card-number">
    {{ props.value }}
  </div>
</template>

<script>
export default {
  height: 16,
}
</script>
